import { useMemo } from 'react';
import clsx from 'clsx';
import { variant } from './utils';

const BBadge = ({
  children,
  color = variant.color.gray,
  size = 'small',
  className = 'h-fit w-fit flex gap-1 items-center',
  rounded = 'rounded-[100px]',
}) => {
  const sizeCls = useMemo(() => {
    switch (size) {
      case 'small':
        return 'py-0.5 px-2.5 text-xs font-medium leading-tight';
      case 'medium':
        return 'py-1.5 px-2.5 text-xs font-medium leading-tight';
      case 'large':
        return 'py-0.5 px-4 text-sm font-medium leading-tight';
      default:
        return '';
    }
  }, [size]);
  return <div className={clsx(className, color, sizeCls, rounded)}>{children}</div>;
};

export default BBadge;
